export default "__VITE_ASSET__CLyjPfgB__"